import { CurrentUserDto } from '../../../../../types/UserDtos';
import { ADMIN_BILLING_CHECKOUT } from '../../../../routes';
import { prependAppPath } from '../../../services/Url';

export const isOnAutomatedBilling = (currentUser: CurrentUserDto) => currentUser.company.onAutomatedBilling;

const CHECKOUT_URL = prependAppPath(ADMIN_BILLING_CHECKOUT);

export function getAdminBillingUrl(user: CurrentUserDto) {
    return Promise.resolve(isOnAutomatedBilling(user) ? CHECKOUT_URL : null);
}
